import { useCallback } from 'react';
import { useModal } from '@ebay/nice-modal-react';

import { usePaymentProvider } from '@ocx/data-payment-provider';
import { ModalFullScreenDrawer, ModalFullScreenHeader } from '@ocx-app/components/modals';

import { AddCardIFrameBasedController } from './features/add-card-iframe-based/add-card-iframe-based.controller';
import { AddCardController, AddCardControllerProps } from './features/add-card-sdk-based/add-card-sdk-based.controller';

export type AddPaymentInstrumentPopupProps = {
  type: AddCardControllerProps['type'];
  onCreated?(params: { paymentInstrumentId: string | null }): void;
};

export const AddPaymentInstrumentPopupController = (props: AddPaymentInstrumentPopupProps) => {
  const { type, onCreated } = props;
  const paymentProvider = usePaymentProvider();

  const modal = useModal();
  const handleCreated = useCallback(
    (params: { paymentInstrumentId: string | null }) => {
      onCreated?.(params);
      modal.hide();
    },
    [modal, onCreated],
  );

  return (
    <ModalFullScreenDrawer open={modal.visible} onClose={modal.hide} onExited={modal.remove}>
      <ModalFullScreenHeader onBackClick={modal.hide} />
      {paymentProvider.tokenizationMechanism === 'SDK' && <AddCardController type={type} onCardAdded={handleCreated} />}
      {paymentProvider.tokenizationMechanism === 'IFRAME' && (
        <AddCardIFrameBasedController onCardAdded={handleCreated} />
      )}
    </ModalFullScreenDrawer>
  );
};
